import { useMemo } from 'react';
import { useCurrentUser } from '../hook';

import useAsset from '../hook/useAsset';

export const useUserRole = () => {
  const { user } = useCurrentUser();
  const { constants } = useAsset();
  const {
    isAdmin = false,
    isUser = false,
    isCustomerSuccess = false,
    isOps = false,
  } = useMemo(() => {
    if (!user) return {};
    const { is_ops: isOps = false } = user;
    const { is_active: isActive, role } = user.organization_membership;
    return {
      isAdmin: isActive && role === constants.ORGANIZATION_ROLE_ADMIN,
      isUser: isActive && role === constants.ORGANIZATION_ROLE_USER,
      isCustomerSuccess:
        isActive && role === constants.ORGANIZATION_ROLE_CUSTOMER_SUCCESS,
      isOps: isActive && isOps,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(user), constants]);
  return { isAdmin, isUser, isCustomerSuccess, isOps };
};
